'use client';
import { createContext, useContext } from 'react';

import { IUserRoleType } from 'model/profiles';
import { UserGQL } from 'model/User';

export interface IUserContext {
  user: UserGQL;
  hasRole: (role: IUserRoleType | IUserRoleType[]) => boolean;
}

export const UserContext = createContext<IUserContext>({} as IUserContext);
export const useUserContext = () => useContext(UserContext);

export const toUserContext = (user: UserGQL): IUserContext => ({
  user,
  hasRole: (role) => {
    if (Array.isArray(role)) {
      return role.some((roleType) => user.roles.some((r) => r.role === roleType));
    }
    return user.roles.some((r) => r.role === role);
  },
});
